import { useAuth0 } from '@auth0/auth0-react'
import { useCallback } from 'react'

import { clearStoredAppTimezonePreference } from '@sparkai/utils'

import { clearRememberedSsoConnection } from '../utils/ssoConnection'

export function useLogout() {
  const { logout } = useAuth0()

  return useCallback(() => {
    clearStoredAppTimezonePreference()
    clearRememberedSsoConnection()
    logout({ returnTo: getReturnToUrl() })
  }, [logout])
}

const getReturnToUrl = () => {
  if (import.meta.env.DEV) {
    return 'http://localhost:3003/' // @sparkai/app-redirector url
  }

  return `${window.location.origin}/`
}
